import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useVerifiedUser } from '../services/authSync';
import { t } from '../i18n';
import { APP_TOAST_EVENT, dispatchAppEvent } from '../services/authEvents';

// Protected route component for vendor dashboard pages (CLAUDE.md step D16).
// Re-checks the current token's user on every navigation/auth change (R0).
const VendorRoute = ({ children }) => {
  const { checking, user } = useVerifiedUser();
  const denied = !checking && !!user && user.role !== 'vendor';

  useEffect(() => {
    if (denied) {
      dispatchAppEvent(APP_TOAST_EVENT, {
        severity: 'info',
        message: t('vendorRoute.denied'),
      });
    }
  }, [denied]);

  if (checking) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center" aria-busy="true" aria-live="polite">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-200 border-t-indigo-600" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/?login=true" replace />;
  }

  if (denied) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default VendorRoute;
